export default __webpack_public_path__ + "static/relaxing@2x-cfc265c17718c040a9358c9d510803f5.png";